import React from 'react';

import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { normalizeFixedFeeLabel } from '../../util/fixedFees';
import { LINE_ITEM_FIXED_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const fixedFeeLabel = (fixedFees, index, intl) => {
  const label = normalizeFixedFeeLabel(fixedFees?.[index]?.label);
  return label || intl.formatMessage({ id: 'OrderBreakdown.fixedFee' });
};

/**
 * A component that renders one-time fixed fees.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {Array<Object>} [props.fixedFees] - Fixed fee labels snapshotted on the transaction
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemFixedFeesMaybe = props => {
  const { lineItems, fixedFees = [], intl } = props;
  const feeLineItems = lineItems.filter(item => item.code === LINE_ITEM_FIXED_FEE && !item.reversal);

  return feeLineItems.length > 0 ? (
    <>
      {feeLineItems.map((item, index) => {
        const formattedTotal = formatMoney(intl, item.lineTotal);
        return (
          <div key={`${item.code}-${index}`} className={css.lineItem}>
            <span className={css.itemLabel}>{fixedFeeLabel(fixedFees, index, intl)}</span>
            <span className={css.itemValue}>{formattedTotal}</span>
          </div>
        );
      })}
    </>
  ) : null;
};

export default LineItemFixedFeesMaybe;
